import { sections } from "../content/roadshow";

type SectionNavProps = {
  activeSection: string;
};

export function SectionNav({ activeSection }: SectionNavProps) {
  return (
    <nav className="section-nav" aria-label="路演章节">
      <a className="brand" href="#opening">刷题宝 Roadshow</a>
      <div className="nav-links">
        {sections.map((section) => (
          <a
            key={section.id}
            className={activeSection === section.id ? "is-active" : ""}
            href={`#${section.id}`}
          >
            {section.label}
          </a>
        ))}
      </div>
    </nav>
  );
}
